import React from 'react';
import { FadeIn, Section, SectionLabel, ButtonPrimary, Card } from './UI';
export const OfferSection = () => {
  const checkoutUrl = 'https://inkovacreation.store/shop/0de4a31b-dafb-4911-b0f5-64f146eb7e48';
  const includedItems = ['Guía PDF completa (6 capítulos)', 'Plantilla Operating Agreement (.doc)', 'Checklist de lanzamiento (11 pasos)', 'Acceso inmediato · Descarga directa', 'Garantía de satisfacción 7 días'];
  return <>
      <Section id="cta" className="bg-sectionAlt" data-id="element-70">
        <FadeIn data-id="element-71">
          <div className="text-center mb-8" data-id="element-72">
            <SectionLabel data-id="element-73">Lo que obtienes hoy</SectionLabel>
            <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-headline mb-5 font-bold" data-id="element-74">
              Todo incluido.
              <br data-id="element-75" />
              <span className="text-accent" data-id="element-76">Un solo precio.</span>
            </h2>
          </div>

          <Card className="p-8 md:p-12 max-w-[600px] mx-auto border-accent/30" data-id="element-77">
            {/* Price */}
            <div className="text-center mb-10" data-id="element-78">
              <p className="text-[1.1rem] line-through text-body mb-2" data-id="element-79">$47</p>
              <div className="font-serif text-[4.5rem] md:text-[5.5rem] text-headline font-black leading-none" data-id="element-80">
                $27.99
              </div>
              <span className="inline-block mt-4 bg-cardBorder text-accent px-5 py-1.5 rounded-full text-[0.85rem] font-semibold tracking-wide" data-id="element-81">
                Oferta por tiempo limitado
              </span>
            </div>

            {/* Included list */}
            <ul className="max-w-[420px] mx-auto mb-10 space-y-4" data-id="element-82">
              {includedItems.map((item, i) => <li key={i} className="flex items-center gap-4 text-[1.05rem] text-body" data-id="element-83">
                  <span className="bg-accent text-white w-6 h-6 rounded-full flex items-center justify-center text-[0.75rem] shrink-0" data-id="element-84">
                    ✓
                  </span>
                  <span data-id="element-85">{item}</span>
                </li>)}
            </ul>

            {/* CTA */}
            <div className="text-center" data-id="element-86">
              <ButtonPrimary text="👉 Descargar Ahora $27.99" href={checkoutUrl} className="w-full sm:w-auto" data-id="element-87" />
              <p className="mt-4 text-[0.85rem] text-body" data-id="element-88">
                Pago único · Acceso inmediato · Sin suscripción
              </p>
            </div>
          </Card>
        </FadeIn>
      </Section>

      <Section className="bg-pageBg text-center" data-id="element-89">
        <FadeIn data-id="element-90">
          <span className="text-[4rem] mb-6 block" data-id="element-91">🛡️</span>
          <SectionLabel data-id="element-92">Sin riesgos</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-headline mb-6 font-bold" data-id="element-93">
            Tu inversión está protegida.
          </h2>
          <p className="text-body max-w-[540px] mx-auto mb-3 text-[1.1rem] leading-relaxed" data-id="element-94">
            Si descargas la guía y sientes que no te dio claridad sobre el
            proceso de crear tu empresa en USA, escríbenos y lo resolvemos.
            Queremos que avances, no que desperdicies tu dinero.
          </p>
        </FadeIn>
      </Section>

      <Section className="bg-sectionAlt" data-id="element-95">
        <FadeIn data-id="element-96">
          <SectionLabel data-id="element-97">Quién hay detrás</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-headline mb-8 font-bold" data-id="element-98">
            Creada por
            <br data-id="element-99" />
            <span className="text-accent" data-id="element-100">@inkovacreation</span>
          </h2>

          <Card className="flex flex-col sm:flex-row gap-8 items-start p-8 md:p-10 border-l-[6px] border-l-accent" data-id="element-101">
            <div className="w-[90px] h-[90px] rounded-full bg-deepPurple flex items-center justify-center text-[2.5rem] shrink-0" data-id="element-102">
              🏢
            </div>
            <div data-id="element-103">
              <h3 className="font-serif text-[1.5rem] text-headline mb-3 font-bold" data-id="element-104">
                Inkova LLC
              </h3>
              <p className="text-[1.05rem] text-body mb-3 leading-relaxed" data-id="element-105">
                En Inkova hemos acompañado a decenas de emprendedores latinos a
                crear su empresa en USA con orden, estructura y presencia
                digital, sin perderse en el camino.
              </p>
              <p className="text-[1.05rem] text-body mb-4 leading-relaxed" data-id="element-106">
                Esta guía es el destilado de todo ese proceso, para que tú
                puedas avanzar por tu cuenta con la misma claridad que tienen
                nuestros clientes de consultoría.
              </p>
              <p className="text-accent font-semibold text-[1.05rem]" data-id="element-107">
                ¿Prefieres hacerlo con acompañamiento? Con gusto te ayudamos a
                completar todo el proceso correctamente.
              </p>
            </div>
          </Card>
        </FadeIn>
      </Section>

      <section className="bg-pageBg text-center py-[100px] px-6" data-id="element-108">
        <FadeIn className="max-w-[800px] mx-auto" data-id="element-109">
          <h2 className="font-serif text-[clamp(2.2rem,5vw,3.6rem)] leading-[1.1] text-headline max-w-[680px] mx-auto mb-6 font-bold" data-id="element-110">
            ¿Listo para dar
            <br data-id="element-111" />
            <span className="text-accent" data-id="element-112">el primer paso?</span>
          </h2>
          <p className="text-body max-w-[520px] mx-auto mb-10 text-[1.1rem] leading-relaxed" data-id="element-113">
            Tu empresa en EE.UU. puede estar activa en 2 a 3 semanas. Con la
            ruta correcta. Sin adivinar. Sin errores costosos.
          </p>

          <ButtonPrimary text="👉 Descargar Ruta USA 360 $27.99" href={checkoutUrl} data-id="element-114" />

          <a href="https://wa.me/17863037695" className="block mt-8 text-accent text-[1rem] no-underline hover:underline transition-colors" data-id="element-115">
            📲 ¿Prefieres que lo hagamos por ti? WhatsApp: (786) 303-7695
          </a>
        </FadeIn>
      </section>
    </>;
};